// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Make the entire component scrollable */
.channel-mapping-container {
    max-height: calc(100vh - 150px); /* adjust if your header is taller */
    overflow-y: auto;
    padding: 20px;
  }
  
  /* Ensure table itself has max height */
  .mapping-table {
    overflow-x: auto;
    width: 100%;
  }
  
  /* Sticky header fix */
  /* .sticky-header th {
    position: sticky;
    top: 0;
    background-color: #f9f9f9;
    z-index: 1;
  }
   */

  /* MappingEditor.css */
/* 
.mapping-table .MuiTableCell-head {
  font-weight: bold;
  background-color: #f4f6f8;
  border-bottom: 2px solid #ccc;
} */
/* 
.mapping-table .MuiTableCell-root {
  padding: 4px 8px;
  border-right: 1px solid #e0e0e0;
} */

.mapping-table .MuiTableRow-root {
  border-bottom: 1px solid #e0e0e0;
}

/* .mapping-table .MuiTableRow-root:hover {
  background-color: #f9f9f9;
} */

.mapping-table .MuiTextField-root input {
  font-size: 14px;
  padding: 6px 8px;
}

/* .mapping-table .MuiTableHead-root {
  position: sticky;
  top: 0;
  z-index: 2;
}
 */

/* Avoid double scroll */
body {
  overflow-x: hidden;
}

 

.mapping-table .MuiTableCell-head {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #f4f6f8;
  font-weight: bold;
  border-bottom: 2px solid #ccc;
}


.mapping-table th:first-child,
.mapping-table td:first-child {
  position: sticky;
  left: 0;
  background-color: #ffffff;
  z-index: 5;
  font-weight: bold;
}



.mapping-table .MuiTableCell-head {
  font-weight: bold;
  background-color: #f4f6f8;
  border-bottom: 2px solid #ccc;
}

.mapping-table .MuiTableCell-root {
  padding: 4px 8px;
  font-size: 13px;
  border-right: 1px solid #e0e0e0;
}

.mapping-table .MuiTableRow-root:hover {
  background-color: #f1f1f1;
}



/* new test below */

.channel-mapping-container {
  padding: 24px;
  background-color: #f9f9f9;
  border-radius: 12px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.mapping-table th, .mapping-table td {
  border: 1px solid #ddd;
  padding: 8px;
  font-size: 14px;
}

.mapping-table th {
  background-color: #f3f4f6;
  font-weight: 600;
  text-align: center;
  color: #333;
}

.mapping-table td {
  vertical-align: middle;
}

.mapping-table input {
  padding: 8px;
}

button {
  text-transform: none !important;
}

button.MuiButton-outlinedPrimary {
  color: #1976d2;
  border-color: #1976d2;
}

button.MuiButton-outlinedPrimary:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

button.MuiButton-outlinedError {
  color: #d32f2f;
  border-color: #d32f2f;
}

button.MuiButton-outlinedError:hover {
  background-color: rgba(211, 47, 47, 0.04);
}

button.MuiButton-contained {
  background-color: #1976d2;
  color: white;
}

button.MuiButton-contained:hover {
  background-color: #1565c0;
}



`, "",{"version":3,"sources":["webpack://./src/components/styles/MappingEditor.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,+BAA+B,EAAE,oCAAoC;IACrE,gBAAgB;IAChB,aAAa;EACf;;EAEA,uCAAuC;EACvC;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,sBAAsB;EACtB;;;;;;IAME;;EAEF,sBAAsB;AACxB;;;;;GAKG;AACH;;;;GAIG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;EAKE;;AAEF,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;;;AAIA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;;AAGA;;EAEE,gBAAgB;EAChB,OAAO;EACP,yBAAyB;EACzB,UAAU;EACV,iBAAiB;AACnB;;;;AAIA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA,mBAAmB;;AAEnB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Make the entire component scrollable */\r\n.channel-mapping-container {\r\n    max-height: calc(100vh - 150px); /* adjust if your header is taller */\r\n    overflow-y: auto;\r\n    padding: 20px;\r\n  }\r\n  \r\n  /* Ensure table itself has max height */\r\n  .mapping-table {\r\n    overflow-x: auto;\r\n    width: 100%;\r\n  }\r\n  \r\n  /* Sticky header fix */\r\n  /* .sticky-header th {\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: #f9f9f9;\r\n    z-index: 1;\r\n  }\r\n   */\r\n\r\n  /* MappingEditor.css */\r\n/* \r\n.mapping-table .MuiTableCell-head {\r\n  font-weight: bold;\r\n  background-color: #f4f6f8;\r\n  border-bottom: 2px solid #ccc;\r\n} */\r\n/* \r\n.mapping-table .MuiTableCell-root {\r\n  padding: 4px 8px;\r\n  border-right: 1px solid #e0e0e0;\r\n} */\r\n\r\n.mapping-table .MuiTableRow-root {\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n/* .mapping-table .MuiTableRow-root:hover {\r\n  background-color: #f9f9f9;\r\n} */\r\n\r\n.mapping-table .MuiTextField-root input {\r\n  font-size: 14px;\r\n  padding: 6px 8px;\r\n}\r\n\r\n/* .mapping-table .MuiTableHead-root {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n}\r\n */\r\n\r\n/* Avoid double scroll */\r\nbody {\r\n  overflow-x: hidden;\r\n}\r\n\r\n \r\n\r\n.mapping-table .MuiTableCell-head {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  background-color: #f4f6f8;\r\n  font-weight: bold;\r\n  border-bottom: 2px solid #ccc;\r\n}\r\n\r\n\r\n.mapping-table th:first-child,\r\n.mapping-table td:first-child {\r\n  position: sticky;\r\n  left: 0;\r\n  background-color: #ffffff;\r\n  z-index: 5;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n\r\n.mapping-table .MuiTableCell-head {\r\n  font-weight: bold;\r\n  background-color: #f4f6f8;\r\n  border-bottom: 2px solid #ccc;\r\n}\r\n\r\n.mapping-table .MuiTableCell-root {\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  border-right: 1px solid #e0e0e0;\r\n}\r\n\r\n.mapping-table .MuiTableRow-root:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n\r\n\r\n/* new test below */\r\n\r\n.channel-mapping-container {\r\n  padding: 24px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 12px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.mapping-table th, .mapping-table td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.mapping-table th {\r\n  background-color: #f3f4f6;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  color: #333;\r\n}\r\n\r\n.mapping-table td {\r\n  vertical-align: middle;\r\n}\r\n\r\n.mapping-table input {\r\n  padding: 8px;\r\n}\r\n\r\nbutton {\r\n  text-transform: none !important;\r\n}\r\n\r\nbutton.MuiButton-outlinedPrimary {\r\n  color: #1976d2;\r\n  border-color: #1976d2;\r\n}\r\n\r\nbutton.MuiButton-outlinedPrimary:hover {\r\n  background-color: rgba(25, 118, 210, 0.04);\r\n}\r\n\r\nbutton.MuiButton-outlinedError {\r\n  color: #d32f2f;\r\n  border-color: #d32f2f;\r\n}\r\n\r\nbutton.MuiButton-outlinedError:hover {\r\n  background-color: rgba(211, 47, 47, 0.04);\r\n}\r\n\r\nbutton.MuiButton-contained {\r\n  background-color: #1976d2;\r\n  color: white;\r\n}\r\n\r\nbutton.MuiButton-contained:hover {\r\n  background-color: #1565c0;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
